import { useEffect } from "react";
import ApiClient from "utils/ApiClient";

export default function useCalEmbed(open, handleScheduleCallCloseAll) {
  useEffect(() => {
    if (!open) return;
    (function (C, A, L) {
      let p = function (a, ar) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
          }
          if (ar[0] === "init") {
            const api = function () {
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            if (namespace) {
              cal.ns[namespace] = cal.ns[namespace] || api;
            } else {
              cal.q = cal.q || [];
            }
            return api;
          }
          p(cal, ar);
        };
    })(window, "https://app.cal.com/embed/embed.js", "init");
    window.Cal("init", { origin: "https://cal.com" });

    window.Cal("on", {
        action: "bookingSuccessful",
        callback: async (e) => {
          console.log("Tigersheet: Booking confirmed!", e);
          if(e?.detail?.type == "bookingSuccessful" && window.appStore.userStore.user.is_onboarding_prompt_visible) {
            const resp = await ApiClient.Account.updateOnboardingPrompt({
              user_id: window.appStore.userStore.user.user_id,
              prompt_value: 0,
            });
            if(resp.success) {
              window.appStore.userStore.user.is_onboarding_prompt_visible = false;
            }
          }
          handleScheduleCallCloseAll();
        }
    });
    return () => {
        if(handleScheduleCallCloseAll) {
            window.Cal("off", {
                action: "bookingSuccessful",
                callback: handleScheduleCallCloseAll
            })
        }
    }
  }, [open, handleScheduleCallCloseAll]);
}